export const getLoaderIsOpen = ({ state }) => state.loaderReducer.isLoaderOpen;
